'use strict';

var assign = require('object-assign');

module.exports = function (Class) {
  function WrappedClass() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new (Function.prototype.bind.apply(Class, [null].concat(args)))();
  }
  assign(WrappedClass, Class);
  WrappedClass.prototype = Class.prototype;
  return WrappedClass;
};